'use client';
import { lazy, Suspense, type ComponentProps } from 'react';
export type * from "/tmp/build-399/node_modules/@eliadmin/core/src/pages/(profile)/loyalty-program/page.tsx";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-399/node_modules/@eliadmin/core/src/pages/(profile)/loyalty-program/page.tsx").default>>;
const Deferred = lazy(() => import("@eliadmin/route-original/22f15f6fe3a3"));
function DeferredRoute(props: Props) { return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }
export default DeferredRoute;

